import ClientesScreen from "../../Base/Screens/Clientes/ClientesScreen";

export const FinanzasRouters = [
  {
    path: "Finanzas/Clientes",
    permiso: 52,
    element: <ClientesScreen />,
  },
];

export default FinanzasRouters;
